import React from 'react';
import PropTypes from 'prop-types';

/**
 * Componente que fica abaixo de um texto, como um informativo.
 * 
 * @param {Object} props
 * @param {string} props.text - O texto informativo a ser exibido.
 * @param {string} [props.className] - Classes CSS adicionais.
 * @param {string} [props.color] - Cor do texto (default: text-muted).
 */
const TextInformative = ({ text, className = '', color = 'text-muted' }) => {
  if (!text) return null;

  return (
    <div className={`mt-1 ${color} ${className}`} style={{ fontSize: '0.85rem' }}>
      <small>
        <i className="fas fa-info-circle mr-1" />
        {text}
      </small>
    </div>
  );
};

TextInformative.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  color: PropTypes.string
};

export default TextInformative;
